export default __webpack_public_path__ + "static/media/arrow-grey-up.dd4f87fa.svg";